import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {  Modal, Card ,  Button, Form, Row, Col} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';
import DatePicker from "react-datepicker";

import "./index.css";
class DialerManagement extends Component {
    constructor(props) {

        super(props);
        this.state = {
            dialerList: [],
            selectedDialerId: 0,
            showAddCreditModal: false,
            sizePerPage: 10,
            startDate : '',
            endDate : '',
            dialerUsageList : '',
            noDataDisplayMsg: '',
            usageFlag : false,
            usageJson : '',
            usageJSONObj : [],
            searchTerm: '' 
        }
    }
    componentDidMount() {
        this.getDialerUsage();
        const savedSizePerPage = Cookies.get('dialerListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }


    getDialerUsage = () => {
        const apiPath = this.props.app.apiPath;

        let sDate = "";
        let eDate ="";
        if(this.state.startDate === ""){
            sDate = this.state.startDate
        }else{
            sDate =  this.formatDate(this.state.startDate)
        }
        if(this.state.endDate === ""){
            eDate = this.state.endDate
        }else{
            eDate =  this.formatDate(this.state.endDate)
        }
        if (new Date(sDate) > new Date(eDate)) {
            Notify.notify("Start date cannot be greater than end date.");
            return;
        }
        const data = {
                startDate : sDate,
                endDate : eDate,
        }
        
        return Fetcher.post(`${apiPath}/api/obd/dialer/usage`, { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
                .then(res => {
                    this.setState({'dialerUsageList': res});
                    if(res.length == 0) {
                        this.setState({noDataDisplayMsg: 'No records found'});
                    }
                })
                .catch(err => {
                    console.log('Error in fetching Dialer Usage Details ', err);
                    Notify.notify('Error in fetching Dialer Usage Details');
                });

        
    }

    formatDate = (date) => {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
	
		return `${year}-${month}-${day}`;
	};

    statusButton = (id , usageJson) => {
                       return (<>
                           <Button variant="success" type="button" onClick={(e) => this.showUsageModal(true,id,usageJson)}>View Details</Button>
                    </>);
    }

    getDialerUsageFilter = (e) => {
        const apiPath = this.props.app.apiPath;
        e.preventDefault();

        let sDate = "";
        let eDate ="";
        if(this.state.startDate === ""){
            sDate = this.state.startDate
        }else{
            sDate =  this.formatDate(this.state.startDate)
        }
        if(this.state.endDate === ""){
            eDate = this.state.endDate
        }else{
            eDate =  this.formatDate(this.state.endDate)
        }
        if (new Date(sDate) > new Date(eDate)) {
            Notify.notify("Start date cannot be greater than end date.");
            return;
        }
        const data = {
                startDate : sDate,
                endDate : eDate,
        }
        
        return Fetcher.post(`${apiPath}/api/obd/dialer/usage`, { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
                .then(res => {
                    this.setState({'dialerUsageList': res});
                    if(res.length == 0) {
                        this.setState({noDataDisplayMsg: 'No records found'});
                    }
                })
                .catch(err => {
                    console.log('Error in fetching Dialer Usage Details ', err);
                    Notify.notify('Error in fetching Dialer Usage Details');
                });

        
    }


    showUsageModal = (status, dialerId, ujson) => {
          
        console.log(".... String : "+ JSON.stringify(ujson));
        this.setState({
            usageFlag: status,
            usageJSONObj: JSON.parse(ujson)
        });
    }

    

    setvalue = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    handleStartDateChange = (date) => {
		this.setState({
			startDate: date,
	    });
    };

    closeModal = (status) => {
		this.setState({
			usageFlag : status
		});
	}

    handleEndDateChange = (date) => {
    		this.setState({
    			endDate: date,
    	 });
    };

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('dialerListsizePerPage', newSizePerPage);
    }

    render() {

        const dialerUsageList = this.state.dialerUsageList;
        var columns;
        
            columns = [
                {
                    dataField: 'id',
                    text: 'Id',
                    sort: true,
                    hidden: false
                },
                {
                    dataField: 'timestamp',
                    text: 'Timestamp',
                    sort: true,
                    hidden: false
                },
                {
                    dataField: 'action',
                    text: 'Action',
                    sort: false,
                    searchable: false
                },];
        
        const dialer = Array.isArray(dialerUsageList) ? dialerUsageList.map((dialers, index) => {
                return {
                    id: dialers.id,
                    timestamp : dialers.timestamp,
                    action: this.statusButton(dialers.id,dialers.dialerUsageJSON)
                };
        }) : []
        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'dialerId',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: dialer.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                <Card.Header>Dialer Usage</Card.Header>
                <Card.Body>
                    <div className="widget-list-table-cont">

                        <Form className="add-campaign-form" method='post' onSubmit={(e) => this.getDialerUsageFilter(e)}>
                            <Row>  
                                <Col sm={3}>
                                    <Form.Group className="form-group">
					                    <DatePicker
						                    className="form-control"
						                    dateFormat="yyyy-MM-dd"
                                            selected={this.state.startDate}
                                            onChange={this.handleStartDateChange}
                                            placeholderText="Start Date"
                                            maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
					                    />
				                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="form-group">
					                    <DatePicker
						                    className="form-control"
						                    dateFormat="yyyy-MM-dd"
						                    selected={this.state.endDate}
                                            onChange={this.handleEndDateChange}
                                            placeholderText="End Date"
                                            maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
					                    />
				                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Button variant="primary" type="submit">Search</Button>
                                </Col>
                            </Row>
                        </Form>
                        <br/>

                        <PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {({
                                paginationProps, paginationTableProps
                            }) => (
                                <ToolkitProvider
                                    keyField="reqDate"
                                    data={dialer}
                                    columns={columns}
                                    search
                                    bootstrap4
                                >
                                    {
                                        props => (
                                            <div className="">
                                                Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                                <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                                <ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
                                                <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.refreshPage()}>Refresh</Button>
                                                <hr />
                                                <BootstrapTable defaultSorted={defaultSorted} bordered={true} striped={true} condensed wrapperClasses="table-responsive" classes="widgetlist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={this.state.noDataDisplayMsg} />
                                                <PaginationListStandalone {...paginationProps} />
                                            </div>
                                        )}
                                </ToolkitProvider>
                            )}
                        </PaginationProvider>
                    </div>

                    <Modal size="lg" show={this.state.usageFlag} onHide={() => this.closeModal(false, '','')}>
                        <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-sm">
                                Dialer Usage Details
                        </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                             <input
                                   type="text"
                                   className="form-control mb-3"
                                   placeholder="Search by Dialer Name"
                                   value={this.state.searchTerm}
                                   onChange={(e) => this.setState({ searchTerm: e.target.value })}
                             />

                            <div className="row">
                              {this.state.usageJSONObj
                                .filter(item =>
                                    item.dialer_name.toLowerCase().includes(this.state.searchTerm.toLowerCase())
                                 )
                                 .map((item, index) => (
                                   <div className="col-md-6 mb-4" key={index}>
                                    <div className="card bg-light border-0 shadow-sm h-100">
                                      <div className="card-body">
                                          <h5 className="card-title text-danger">{item.dialer_name}</h5>
                                          <p className="card-text">
                                            <strong>Trunk:</strong> {item.trunk_name}<br />
                                            <strong>Dialer ID:</strong> {item.dialer_id}<br />
                                            <strong>Total Duration:</strong> {item.total_duration} seconds<br />
                                            <strong>Date:</strong> {item.date}
                                          </p>
                                    </div>
                                    </div>
                                    </div>
                                  ))}
                                </div>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button onClick={() => this.closeModal(false, '','')} variant="primary">CANCEL</Button>
                        </Modal.Footer>
                    </Modal>

                </Card.Body>
            </Card>

        );
    }
}

export default DialerManagement;